import React, { useState, useEffect } from 'react';
import MVP from './MVP';
import GoalWizard from './GoalWizard';
import Mixpanel from '../utils/mixpanel';

const Plan = () => {
  // MVP is the only plan available in this version
  const [showWizard, setShowWizard] = useState(false);
  const [hasSeenWizard, setHasSeenWizard] = useState(false);
  
  useEffect(() => {
    // Track feature usage with enhanced page tracking
    Mixpanel.trackEnhancedPageView('/plan', 'Planning Tools', {
      feature: 'Plan',
      action: 'Opened',
      active_plan: 'mvp'
    });
    
    // Check if the user has seen the wizard before
    const wizardSeen = localStorage.getItem('goalWizardSeen');
    setHasSeenWizard(!!wizardSeen);
    
    // Show wizard for new users
    if (!wizardSeen) {
      setShowWizard(true);
    }
  }, []);
  
  // Plan change handler removed as only MVP is available in this version
  
  const handleWizardComplete = (formData) => {
    // Mark wizard as seen
    localStorage.setItem('goalWizardSeen', 'true');
    setHasSeenWizard(true);
    setShowWizard(false);
    
    // Refresh MVP data if needed
    // You might want to add a refresh method to the MVP component
  };
  
  const handleWizardClose = () => {
    // Mark wizard as seen even if they skip
    localStorage.setItem('goalWizardSeen', 'true');
    setHasSeenWizard(true);
    setShowWizard(false);
  };

  return (
    <div className="container mx-auto p-4 max-w-4xl">
      {/* Goal Wizard */}
      <GoalWizard 
        isOpen={showWizard} 
        onClose={handleWizardClose}
        onComplete={handleWizardComplete}
      />
      
      {/* New Title and Goal Setting Wizard Link */}
      <div className="flex flex-col items-center mb-8">
        <h1 className="text-2xl md:text-3xl font-bold text-primary mb-2 text-center">Your Mission, Vision, and Process Goals</h1>
        <button
          className="btn btn-primary mb-2"
          onClick={() => setShowWizard(true)}
        >
          Goal Setting Wizard
        </button>
      </div>
      {/* Plan Content */}
      <div>
        <MVP />
      </div>
    </div>
  );
};

export default Plan;